import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";

export const StyledNotificationCardContentLoader = styled(ContentLoader)`
  height: 40px;
  width: 100%;
`;

export const TaskContextSearchLoader = () => (
  <StyledNotificationCardContentLoader
    height={40}
    preserveAspectRatio="xMinYMid meet"
    width={448}
  >
    <rect height="10" width="100" x="10" y="8" />
    <rect height="8" width="83" x="10" y="23" />
    <rect height="8" width="40" x="105" y="23" />
    <rect height="8" width="60" x="155" y="23" />
  </StyledNotificationCardContentLoader>
);
